
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/moje-konto/zmien-termin-instalacji",
      function () {
        return require("private-next-pages/moje-konto/zmien-termin-instalacji/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/moje-konto/zmien-termin-instalacji"])
      });
    }
  